module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Hitler’s Wolfsschanze")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("The Wolf’s Lair Headquarters on the Eastern Front – An Illustrated Guide")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("John Grehan")]), _vm._v(" "), _c('div', {
    staticClass: "img_containerr"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("AN IMPRINT OF PEN & SWORD BOOKS LTD")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("YORKSHIRE – PHILADELPHIA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0f69be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0